import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Segmento } from '../../_models/segmento';
import { SegmentoIngresoService } from '../../_services/segmento-ingreso.service';
import { SegmentoIngreso } from '../../_models/segmento-ingreso';
import {forkJoin} from 'rxjs';
import {SegmentoActividadesService} from '../../_services/segmento-actividades.service';

@Component( {
  templateUrl: 'segmento-ingresos.component.html',
  selector: 'app-segmento-ingresos',
  providers: [ ConfirmationService ]
} )
export class SegmentoIngresosComponent implements OnInit {
  @Input() detalle: boolean = false;
  columnas: any[];
  columnasH: any[];
  formulario: FormGroup;
  carSegmentoIngreso: boolean;
  segmentoIngresos: SegmentoIngreso[] = [];
  segmentoTipoOcIngresos: SegmentoIngreso[] = [];
  @Input()
  segmento: Segmento;
  @Input()
  segmentoTemp: any;
  submitted: boolean;
  guardando: boolean;
  rangoDesdeValido = true;
  rangoInvalido = false;
  edit = false;
  cargando = true;

  constructor( private navServicio: NavService,
               private router: Router,
               private formBuilder: FormBuilder,
               private segmentoIngresoService: SegmentoIngresoService,
               private confirmacionServicio: ConfirmationService,
               private segmentoActividadesService : SegmentoActividadesService) {
  }


  ngOnInit(): void {
    this.formulario = this.formBuilder.group( {
      idSegmentoIngreso: [ null ],
      nombreRango: [ '', [ Validators.required ] ],
      rangoDesde: [ '', [ Validators.required ] ],
      rangoHasta: [ '', [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );
    this.columnas = [
      { field: 'nombreRango', header: this.navServicio.buscarMensaje( 'SEGMENTOSINGRESOS.LBL_NOMBRERANGO' ), sort: true },
      { field: 'rangoDesde', header: this.navServicio.buscarMensaje( 'SEGMENTOSINGRESOS.LBL_RANGODESDE' ), sort: true },
      { field: 'rangoHasta', header: this.navServicio.buscarMensaje( 'SEGMENTOSINGRESOS.LBL_RANGOHASTA' ), sort: true },
    ];
    if ( !this.detalle ) {
      this.columnas.push( { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
    }
    this.columnasH = [
      { field: 'nombreRango', header: this.navServicio.buscarMensaje( 'SEGMENTOSINGRESOS.LBL_NOMBRERANGO' ), sort: true },
      { field: 'rangoDesde', header: this.navServicio.buscarMensaje( 'SEGMENTOSINGRESOS.LBL_RANGODESDE' ), sort: true },
      { field: 'rangoHasta', header: this.navServicio.buscarMensaje( 'SEGMENTOSINGRESOS.LBL_RANGOHASTA' ), sort: true }
    ];
    forkJoin(
      this.segmentoIngresoService.listadoTipoOcupacionHabilitados( this.segmento.idSegmento ),
      this.segmentoIngresoService.obtenerPorSegmento( this.segmento.idSegmento )
    ).subscribe( ( [ res1, res2 ] ) => {
      this.segmentoTipoOcIngresos = res1;
      this.segmentoIngresos = res2;
      this.cargando =false;
    }, ( err1 ) => {
      this.navServicio.setMesage( 4, {
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar la información. Intente nuevamente.'
      } );
    } );
  }


  get f() {
    return this.formulario.controls;
  }

  get segIngresos() {
    this.segmentoIngresos.sort(function (a, b) {
      if (a.rangoDesde > b.rangoDesde) {
        return 1;
      }
      if (a.rangoDesde < b.rangoDesde) {
        return -1;
      }
      return 0;
    });
    return this.segmentoIngresos.filter( s => s.indicadorHabilitado );

  }

  validarValor( event: any, desde: boolean ) {
    const rangoDesde = this.formulario.controls.rangoDesde.value;
    const rangoHasta = this.formulario.controls.rangoHasta.value;
    if ( desde && rangoHasta ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoDesdeValido = false;
      } else {
        this.rangoDesdeValido = true;
      }
    } else if ( !desde && rangoDesde ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoDesdeValido = false;
      } else {
        this.rangoDesdeValido = true;
      }
    }
  }

  validarRango(): boolean {
    const rangoDesde = Number( this.f.rangoDesde.value);
    const rangoHasta = Number( this.f.rangoHasta.value );
    const idSegmentoIngreso = this.formulario.controls.idSegmentoIngreso.value;
    let validacion = true;
    if(this.segmentoTipoOcIngresos && this.segmentoTipoOcIngresos.length >0){
      const dato1 = this.segmentoTipoOcIngresos.find( x => x.rangoDesde <= Number( rangoDesde ) && x.rangoHasta > Number( rangoDesde ) && x.indicadorHabilitado);
      const dato2 = this.segmentoTipoOcIngresos.find( x => x.rangoDesde < Number( rangoHasta ) && x.rangoHasta >= Number( rangoHasta ) && x.indicadorHabilitado );
      if ( (dato1 && dato1.idSegmentoingreso !== idSegmentoIngreso && dato1.indicadorHabilitado)
        || (dato2 && dato2.idSegmentoingreso !== idSegmentoIngreso && dato2.indicadorHabilitado) ) {
        validacion = false;
      } else {
        this.segmentoTipoOcIngresos.map( ( s: SegmentoIngreso ) => {
          if(s.indicadorHabilitado && s.idSegmentoingreso !== idSegmentoIngreso){
            const datoMin = Number(s.rangoDesde);
            const datohas = Number(s.rangoHasta);
            if (rangoDesde > datoMin  && rangoDesde < datohas ){
              validacion = false;
            }
            if ( rangoHasta > datoMin && rangoHasta < datohas ){
              validacion = false;
            }
            if ( datoMin > rangoDesde && datoMin < rangoHasta ){
              validacion = false;
            }
          }
        } );
      }
    }
    return validacion;
  }

  onSubmit(): void {
    this.submitted = true;
    this.rangoInvalido = this.validarRango();
    if(this.rangoDesdeValido && this.rangoInvalido  && this.formulario.valid){
      this.guardando = true;
      this.carSegmentoIngreso = true;
      const temp: SegmentoIngreso = this.formulario.value;
      const a = this.segmentoIngresos.find( sp => sp.idSegmentoIngreso === temp.idSegmentoIngreso );
      if ( a ) {
        temp.idSegmentoIngreso = a.idSegmentoIngreso;
      }
      temp.idSegmento = this.segmento.idSegmento;
      temp.indicadorHabilitado = true;
      if ( temp.idSegmentoIngreso ) {
        this.segmentoIngresoService.actualizar( temp ).subscribe( res => {
          const lista = Object.assign( [], this.segmentoIngresos );
          const listaTem = Object.assign( [], this.segmentoTipoOcIngresos );
          this.segmentoIngresos = [];
          this.segmentoTipoOcIngresos = [];
          lista.map( x => {
            if ( x.idSegmentoIngreso === temp.idSegmentoIngreso ) {
              x = temp;
            }
            this.segmentoIngresos.push( x );
          } );
          listaTem.map( x => {
            if ( x.idSegmentoIngreso === temp.idSegmentoIngreso ) {
              x = temp;
            }
            this.segmentoTipoOcIngresos.push( x );
          } );

          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoIngreso = false;
          this.guardando = false;
          this.edit = false;
          this.navServicio.setMesage( 2 );
        }, error1 => {
          this.navServicio.setMesage( 3 );
          this.carSegmentoIngreso = false;
          this.guardando = false;
          this.edit = false;
        } );
      } else {
        this.segmentoIngresoService.agregar( temp ).subscribe( res => {
          temp.idSegmentoIngreso = res.idSegmentoIngreso;
          temp.idSegmentoingreso = res.idSegmentoIngreso;

          if(!this.segmentoTipoOcIngresos ){
            this.segmentoTipoOcIngresos = [];
          }
          this.segmentoIngresos.push( temp );
          this.segmentoTipoOcIngresos.push( temp );
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoIngreso = false;
          this.guardando = false;
          this.navServicio.setMesage( 1 );
        }, error1 => {
          this.navServicio.setMesage( 3 );
          this.carSegmentoIngreso = false;
          this.guardando = false;
        } );
      }
    }
  }

  editar( row: SegmentoIngreso ): void {
    this.edit = true;
    this.submitted = false;
    this.formulario = this.formBuilder.group( {
      idSegmentoIngreso: [ row.idSegmentoIngreso ? row.idSegmentoIngreso : null ],
      nombreRango: [ row.nombreRango ? row.nombreRango : null, [ Validators.required ] ],
      rangoDesde: [ (row.rangoDesde !== null && row.rangoDesde !== undefined) ? row.rangoDesde : null, [ Validators.required ] ],
      rangoHasta: [ row.rangoHasta ? row.rangoHasta : null, [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );
  }

  disable( row: SegmentoIngreso ): void {
    this.confirmacionServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Ingresos',
      icon: 'fa fa-question-circle',
      key: 'ingreso',
      accept: () => {
        row.indicadorHabilitado = false;
        this.segmentoIngresoService.actualizar( row ).subscribe( res => {

          this.formulario.reset();
          this.submitted = false;
          this.edit = false;
          const temp: SegmentoIngreso[] = this.segmentoIngresos;
          const tem: SegmentoIngreso[] = this.segmentoTipoOcIngresos;
          this.segmentoIngresos = [];
          this.segmentoTipoOcIngresos = [];
          temp.map( t => {
            if ( t.idSegmentoIngreso === row.idSegmentoIngreso ) {
              t.indicadorHabilitado = false;
            }
          } );
          tem.map( t => {
            if ( t.idSegmentoingreso === row.idSegmentoIngreso ) {
              t.indicadorHabilitado = false;
            }
          } );
          this.segmentoIngresos = temp;
          this.segmentoTipoOcIngresos = tem;
          this.formulario.reset();
        } );
      }
    } );
  }

}
